<div *ngIf="cart$ | async as cart"
     class="mb-submit-order-wrapper"
     data-cy="mb-submit-order-wrapper">

  <mb-submit-order-request *ngIf="!isPurchaseCheckout"
                           [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, cart)"
                           [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_MIX, cart)"
                           [totalPrice]="cart.totalPrice">
  </mb-submit-order-request>

  <mb-submit-order-price *ngIf="isPurchaseCheckout"
                         [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_AVAILABLE, cart)"
                         [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, cart)"
                         [totalPrice]="cart.totalPrice"
                         [showShippingTaxes]="false">
  </mb-submit-order-price>

  <div class="row no-gutters mt-2 mb-submit-order-totals"
       data-cy="mb-submit-order-totals">
    <ng-container *ngIf="isPurchaseCheckout">
      <div class="col-6 mt-3"
           data-cy="mb-submit-order-title">
        <span>{{'mbcommon.estimatedSubtotal' | cxTranslate}}</span>
      </div>

      <div class="col-6 mt-3 text-right"
           data-cy="mb-submit-order-price">
        <span><strong>{{cart.totalPrice.formattedValue}}</strong></span>
      </div>
    </ng-container>

    <div class="col-12 my-3 mb-request-info"
         data-cy="mb-submit-order-step-info">
      <span *ngIf="isPurchaseCheckout">{{'submitBox.taxesInfo' | cxTranslate}}</span>
      <span *ngIf="!isPurchaseCheckout">{{'submitBox.requestInfo' | cxTranslate}}</span>
    </div>
  </div>
</div>
